import React from 'react';
import ReactDOM from 'react-dom';
import "./i18n";
import Schedule from './components/Schedule';

window.displayHours = function (el) {
    ReactDOM.render(
        <React.StrictMode>
            <Schedule adherentCode={el.dataset.adherentCode}/>
        </React.StrictMode>,
        el
    );
}

document.addEventListener("DOMContentLoaded", function() {
    let scheduleElements = document.getElementsByClassName("ax_hours_schedule");
    if (scheduleElements.length) {
        for (let el of scheduleElements) {
            window.displayHours(el)
        }
    }
});